import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Radio } from './controls';

export class RadioGroup extends React.PureComponent {
  // for now eslint-plugin-react doesn't recognize `getDerivedStateFromProps`
  // which is introduced in React 16.3
  static propTypes = {
    checked: PropTypes.any, // eslint-disable-line
    getItemId: PropTypes.func,
    getItemValue: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.any).isRequired,
    name: PropTypes.string, // eslint-disable-line
    onChange: PropTypes.func.isRequired,
    renderItem: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    checked: null,
    getItemId: (item, index) => String(index),
    getItemValue: null,
    name: null,
    renderItem: () => null,
    className: null,
    disabled: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      name: nextProps.name || prevState.name || _.uniqueId('radio-group-'),
    };
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const getItemValue = this.props.getItemValue || this.props.getItemId;

    return (
      <React.Fragment>
        {this.props.items.map((item, index) => {
          const id = this.props.getItemId(item, index);
          const onChange = () => {
            this.props.onChange(item);
          };

          return (
            <Radio
              key={id}
              id={`${this.state.name}-${id}`}
              className={this.props.className}
              checked={this.props.checked === item}
              name={this.state.name}
              onChange={onChange}
              value={getItemValue(item, index)}
              disabled={this.props.disabled}
            >
              {this.props.renderItem(item, index)}
            </Radio>
          );
        })}
      </React.Fragment>
    );
  }
}
